import BaseConfiguratorService from "@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import {
  setConfigurationLevel
} from "../Reducers/Configurator/Actions";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";

import { switchOptions } from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";

export default class ConfiguratorService extends BaseConfiguratorService {
  async loadInitialConfiguration() {
    await super.loadInitialConfiguration();
    const { configuration } = Services.store.state.configurator;
    const itemIdentifier = configuration?.item?.identifier;
    if (!itemIdentifier) {
      console.error(
        `Missing item identifier! Setting original configuration is not possible.`
      );
      return;
    }
  }
}

export const loadConfigurationByLevel = async (
  itemIdentifier: string,
  level_visibility: number
) => {
  if (!itemIdentifier || !level_visibility) {
    console.error(`Missing item identifier/level_visibility!`);
    return;
  }
  if (level_visibility) {
    Api.setGETParameter("_level_visibility", level_visibility);
  }
  
  Services.store.dispatch(setConfigurationLevel(level_visibility));

  const { configuration } = Services.store.state.configurator;
  Services.store.dispatch(switchOptions(configuration, {}))

};
